// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * Shared responsive sx snippets. Desktop (sm+) must match pre-mobile layouts —
 * only xs overrides change stacking / padding / overflow.
 */

/** Page root: drop extra page padding on phones (Layout already pads). */
export const pageRootSx = {
  p: { xs: 0, sm: 3 },
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  width: '100%',
  boxSizing: 'border-box',
};

/**
 * Title row + action(s). Stacks on xs; row + space-between on sm+ (current desktop).
 * Spread into the existing header Box — do not wrap titles in new typography.
 */
export const pageHeaderSx = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'stretch', sm: 'center' },
  justifyContent: 'space-between',
  gap: 2,
  mb: 3,
  minWidth: 0,
};

/** Right-side action cluster inside a page header. */
export const pageHeaderActionsSx = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 1,
  flexShrink: 0,
  '& .MuiButton-root': {
    width: { xs: '100%', sm: 'auto' },
  },
};

/** Wide data tables: force horizontal scroll instead of crushing columns. */
export const wideTableContainerSx = {
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  minWidth: 0,
};

export const wideTableSx = (minWidth = 900) => ({
  minWidth,
});
